import { render, staticRenderFns } from "./ImportFormPage.vue?vue&type=template&id=5228af5d&"
import script from "./ImportFormPage.vue?vue&type=script&lang=js&"
export * from "./ImportFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports